import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { CHttp } from '../../core/services/chttp.service';
import { config } from '../../app.config';

@Injectable()
export class AdminUsersService {
  constructor(private http: CHttp) {}

  public getAdminUsers(data?: any) {
    return this.http.get(config.api_url + 'admin-users', { params: data });
  }

  public getUser(id: string) {
    return this.http.get(config.api_url + 'admin-users/' + id);
  }

  public addUser(data) {
    return this.http.post(config.api_url + 'admin-users', data);
  }

  public updateUser(data) {
    return this.http.put(config.api_url + 'admin-users', data);
  }

  public changePassword(currentPassword: string, newPassword: string) {
    return this.http.post(config.api_url + 'admin-users/change-password', {
      oldPassword: currentPassword,
      newPassword: newPassword,
    });
  }

  public forgottenPassword(username: string) {
    return this.http.post(config.api_url + 'admin-users/forgotten-password', { username: username });
  }

  public deleteUser(id: string) {
    return this.http.delete(config.api_url + 'admin-users/' + id);
  }

  public blockUser(id: string) {
    return this.http.post(config.api_url + 'admin-users/' + id + '/block');
  }

  public unblockUser(id: string) {
    return this.http.post(config.api_url + 'admin-users/' + id + '/unblock');
  }

  public is2faEnabled(id: string) {
    return this.http.get(config.api_url + 'admin-users/' + id + '/2fa');
  }

  public enabled2fa(id: string) {
    return this.http.post(config.api_url + 'admin-users/' + id + '/2fa');
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/admin-users/services/admin-users.service.ts